// FinalSettlementSec.jsx
import { useState, useRef } from "react";
import { useCaseSettlement } from '../hooks/useCaseSettlement';
import { useOneTimeConfetti } from '../hooks/useOneTimeConfetti';
import FinalSettlementHeader from './FinalSettlementHeader.js';
import SettleAllView from './SettleAllView.js';
import SettlementListView from './SettlementListView.js';
import LoggedInUserService from '../services/AuthService';
import { FinalSettlementSuccess } from "./FinalSettlementSuccess";

const FinalSettlementSec = ({ caseId, caseData }) => {
    const settleAllSubmitRef = useRef(null);
    const user = LoggedInUserService.GetLoggedInUserData();
    const [localCase, setLocalCase] = useState(caseData);
    const plainTiffs = localCase?.clients || [];
    const [openSettlementIndexes, setOpenSettlementIndexes] = useState([]);
    const [showSettleAllView, setShowSettleAllView] = useState(false);
    const { showConfetti, setShowConfetti } =
        useOneTimeConfetti(localCase);

    const {
        submitCaseSettlement,
        isLoading
    } = useCaseSettlement(caseId, null, localCase, setLocalCase);

    // Prepare initial values for Formik
    console.log('plainTiffs',plainTiffs)
    const getInitialValues = () => {
        return plainTiffs.reduce((acc, client) => {
            const s = client?.settlement || {};
            acc[client.clientId] = {
                thirdPartySettlementAmount: s.thirdPartyAmount || '',
                uimUmSettlementAmount: s.uimUmAmount || '',
                isThirdPartyPolicyLimitSettled: Boolean(s.thirdPartyPolicyLimitSettledAt),
                isUimUmPolicyLimitSettled: Boolean(s.uimUmPolicyLimitSettledAt),
                isCaseSettled: Boolean(s.settledAt),
            };
            return acc;
        }, {});
    };

    const toggleSettlementDetails = (index) => {
        if (openSettlementIndexes.includes(index)) {
            setOpenSettlementIndexes(openSettlementIndexes.filter(i => i !== index));
        } else {
            setOpenSettlementIndexes([...openSettlementIndexes, index]);
        }
    };

    const closeSettlementDetails = (index) => {
        setOpenSettlementIndexes(openSettlementIndexes.filter(i => i !== index));
    };

    const handleSettleAllSave = (values) => {
        submitCaseSettlement(values);
        setShowSettleAllView(false);
    };

    const handleSettleAllCancel = () => {
        setShowSettleAllView(false);
    };

    const handleIndividualSave = (values, clientId) => {
        const individualSettlement = { [clientId]: values[clientId] };
        submitCaseSettlement(individualSettlement);
    };

    const settlementSummary = (localCase?.clients || [])
        .filter(c => c.settlement?.settledAt)
        .map(c => ({
            name: c.personalInfo?.clientName || 'N/A',
            amount:
                (Number(String(c.settlement?.thirdPartyAmount || 0).replace(/,/g, '')) || 0) +
                (Number(String(c.settlement?.uimUmAmount || 0).replace(/,/g, '')) || 0)
        }));

    return (
        <>
            {!showConfetti ? (
                <>
                    <FinalSettlementHeader
                        showSettleAllView={showSettleAllView}
                        onSettleAllClick={() => setShowSettleAllView(true)}
                        onCancel={handleSettleAllCancel}
                        onSave={() => settleAllSubmitRef.current?.()}
                        isLoading={isLoading}
                    />

                    {showSettleAllView ? (
                        <SettleAllView
                            plainTiffs={plainTiffs}
                            caseData={caseData}
                            initialValues={getInitialValues()}
                            onCancel={handleSettleAllCancel}
                            onSave={handleSettleAllSave}
                            user={user}
                            submitRef={settleAllSubmitRef}
                            isLoading={isLoading}
                        />
                    ) : (
                        <SettlementListView
                            plainTiffs={plainTiffs}
                            caseData={caseData}
                            initialValues={getInitialValues()}
                            openSettlementIndexes={openSettlementIndexes}
                            onToggleDetails={toggleSettlementDetails}
                            onCloseDetails={closeSettlementDetails}
                            onSave={handleIndividualSave}
                            user={user}
                            isLoading={isLoading}
                        />
                    )}
                </>
            ) : <FinalSettlementSuccess
                settlements={settlementSummary}
                onClose={() => setShowConfetti(false)}
            />}
        </>
    );
};

export default FinalSettlementSec;